import { CalendarEventDto, State } from "../../interfaces";
import { Paginated } from "../../models";
import {
  ADD_CALENDAR_EVENT,
  ADD_CALENDAR_EVENT_ERROR,
  ADD_CALENDAR_EVENT_SUCCESS,
  ActionTypes,
  DELETE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT_CONSENT,
  DELETE_CALENDAR_EVENT_ERROR,
  DELETE_CALENDAR_EVENT_SUCCESS,
  GET_ALL_CALENDAR_EVENTS,
  GET_ALL_CALENDAR_EVENTS_ERROR,
  GET_ALL_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENT,
  GET_CALENDAR_EVENTS,
  GET_CALENDAR_EVENTS_ERROR,
  GET_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENT_ERROR,
  GET_CALENDAR_EVENT_SUCCESS,
  UPDATE_CALENDAR_EVENT,
  UPDATE_CALENDAR_EVENT_ERROR,
  UPDATE_CALENDAR_EVENT_SUCCESS,
} from "./actionTypes";

export class CalendarState {
  calendarEvents!: State<Paginated<CalendarEventDto>>;
  calendarAllEvents!: State<CalendarEventDto[]>;
  calendarEvent!: State<CalendarEventDto>;
  addCalendarEvent!: State<any>;
  updateCalendarEvent!: State<any>;
  deleteCalendarEvent!: State<any>;
  constructor() {
    this.calendarEvents = {
      loading: false,
      error: null,
      success: false,
    };
    this.calendarEvent = {
      loading: false,
      error: null,
      success: false,
    };
    this.addCalendarEvent = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateCalendarEvent = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteCalendarEvent = {
      loading: false,
      error: null,
      success: false,
    };
    this.calendarAllEvents = {
      loading: false,
      error: null,
      success: false,
      response: undefined,
    };
  }
}

const initialState: CalendarState = new CalendarState();

export const calendarEvent = (
  state: CalendarState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_CALENDAR_EVENTS:
      state = {
        ...state,
        calendarEvents: {
          ...state.calendarEvents,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CALENDAR_EVENTS_SUCCESS:
      state = {
        ...state,
        calendarEvents: {
          ...state.calendarEvents,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CALENDAR_EVENTS_ERROR:
      state = {
        ...state,
        calendarEvents: {
          ...state.calendarEvents,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_ALL_CALENDAR_EVENTS:
      state = {
        ...state,
        calendarAllEvents: {
          ...state.calendarAllEvents,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_ALL_CALENDAR_EVENTS_SUCCESS:
      state = {
        ...state,
        calendarAllEvents: {
          ...state.calendarAllEvents,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_ALL_CALENDAR_EVENTS_ERROR:
      state = {
        ...state,
        calendarAllEvents: {
          ...state.calendarAllEvents,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case GET_CALENDAR_EVENT:
      state = {
        ...state,
        calendarEvent: {
          ...state.calendarEvent,
          loading: true,
          success: false,
          error: null,
        },
        addCalendarEvent: {
          ...state.addCalendarEvent,
          loading: false,
          success: false,
          error: null,
        },
        updateCalendarEvent: {
          ...state.updateCalendarEvent,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_CALENDAR_EVENT_SUCCESS:
      state = {
        ...state,
        calendarEvent: {
          ...state.calendarEvent,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_CALENDAR_EVENT_ERROR:
      state = {
        ...state,
        calendarEvent: {
          ...state.calendarEvent,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_CALENDAR_EVENT:
      state = {
        ...state,
        addCalendarEvent: {
          ...state.addCalendarEvent,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_CALENDAR_EVENT_SUCCESS:
      state = {
        ...state,
        addCalendarEvent: {
          ...state.addCalendarEvent,
          loading: false,
          error: null,
          success: true,
        },
        calendarAllEvents: {
          ...state.calendarAllEvents,
          loading: false,
          error: null,
          success: true,
          response: [
            action.payload,
            ...(state.calendarAllEvents.response as []),
          ],
        },
      };
      break;
    case ADD_CALENDAR_EVENT_ERROR:
      state = {
        ...state,
        addCalendarEvent: {
          ...state.addCalendarEvent,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case UPDATE_CALENDAR_EVENT:
      state = {
        ...state,
        updateCalendarEvent: {
          ...state.updateCalendarEvent,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_CALENDAR_EVENT_SUCCESS:
      state = {
        ...state,
        updateCalendarEvent: {
          ...state.updateCalendarEvent,
          loading: false,
          error: null,
          success: true,
        },
        calendarAllEvents: {
          ...state.calendarAllEvents,
          loading: false,
          error: null,
          success: true,
          response: [
            action.payload,
            ...(state.calendarAllEvents.response?.filter(
              (i) => i.id !== action.payload.id
            ) as []),
          ],
        },
      };
      break;
    case UPDATE_CALENDAR_EVENT_ERROR:
      state = {
        ...state,
        updateCalendarEvent: {
          ...state.updateCalendarEvent,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_CALENDAR_EVENT_CONSENT:
      state = {
        ...state,
        deleteCalendarEvent: {
          ...state.deleteCalendarEvent,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_CALENDAR_EVENT:
      state = {
        ...state,
        deleteCalendarEvent: {
          ...state.deleteCalendarEvent,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_CALENDAR_EVENT_SUCCESS:
      state = {
        ...state,
        deleteCalendarEvent: {
          ...state.deleteCalendarEvent,
          loading: false,
          error: null,
          success: true,
        },
        calendarAllEvents: {
          ...state.calendarAllEvents,
          loading: false,
          error: null,
          success: true,
          response: state.calendarAllEvents.response?.filter(
            (i) => i.id !== action.payload
          ),
        },
      };
      break;
    case DELETE_CALENDAR_EVENT_ERROR:
      state = {
        ...state,
        deleteCalendarEvent: {
          ...state.deleteCalendarEvent,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
